import { Spinner } from '@/components/ui/Spinner';

/** Full-viewport loading state used as the Suspense fallback for routes. */
export function PageLoader() {
  return (
    <div className="flex min-h-[60vh] w-full items-center justify-center">
      <Spinner size="lg" className="text-muted" label="Loading page" />
    </div>
  );
}
